module.exports = __webpack_public_path__ + "assets/img/open.ddf11348.png";